import apiClient from "../apiClient";

export const getAllBadgesAPI = async () => {
  try {
    const response = await apiClient.get("badges/badge-actives");
    // console.log("Response Badges APi", response);

    return response?.data?.data ?? [];
  } catch (error) {
    throw error;
  }
};

export const getBadgeAssignedAPI = async (userId) => {
  try {
    const response = await apiClient.post(`badges/assig-badge/${userId}`);

    return response?.data?.data ?? {};
  } catch (error) {
    throw error;
  }
};
export const getHistoryBadgesAPI = async (userId) => {
  try {
    const response = await apiClient.get(`badges/assig-badge/${userId}`);
    return response?.data?.data ?? {};
  } catch (error) {
    throw error;
  }
};
